import type { TItemType } from '@modules/items';

// A "reusable content" document: a document with isBlock set. Structural param so it accepts both
// full item types (TDocument/TFile/TItem) and lean selection types (TSelectedItem).
const isBlockDocument = (item?: { type: TItemType; isBlock?: boolean }): boolean =>
  item?.type === 'DOCUMENT' && Boolean(item?.isBlock);

export default isBlockDocument;
